
import React from "react";

interface LoadingProps {
  isLoading: boolean;
}

export const LoadingSpinner: React.FC<LoadingProps> = ({ isLoading }) => {
  if (!isLoading) return null;
  
  return (
    <div className="flex justify-center items-center h-64">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-synagogue-blue"></div>
    </div>
  );
};

interface ErrorDisplayProps {
  error: string | null;
  onRetry: () => void;
}

export const ErrorDisplay: React.FC<ErrorDisplayProps> = ({ error, onRetry }) => {
  if (!error) return null;
  
  return (
    <div className="text-center p-6">
      <h3 className="text-xl text-red-500 mb-2">שגיאה בטעינת המידע</h3>
      <p>{error}</p>
      <button 
        onClick={onRetry}
        className="mt-4 px-4 py-2 bg-synagogue-blue text-white rounded hover:bg-synagogue-blue/80"
      >
        נסה שוב
      </button>
    </div>
  );
};

export const NoDataDisplay: React.FC = () => {
  return (
    <div className="text-center p-6">
      <p className="text-lg">אין מידע להצגה</p>
    </div>
  );
};
